import { gql } from '@apollo/client';

import { FragmentDealer } from '../dealer';

export const FragmentService = gql`
  fragment FragmentService on Service {
    sku
    title
    price
    description
    images {
      url
    }
    dealer {
      ...FragmentDealer
    }
    abstractProductSku
  }
  ${FragmentDealer}
`;
